// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"21f31201","951":"4f5bce60"}[chunkId] + ".chunk.js";
};